import React from "react";
import {ChipLabel} from "./index";
import _ from "lodash";

const EmailStatusChip = ({status, hoverable= false}) => {
    const colors = {
        invalid: "error",
        valid: "success",
        do_not_mail: "warning",
        "catch-all": "secondary",
        unknown: "unknown",
        spamtrap: "onboarding",
        abuse: "filter",
        totals: "nurture",
        flagged: "warning",
        reviewed: "unknown",
    }

    return (<ChipLabel label={_.startCase(status?.replace(/_/g, ' '))} className={`status-chip ${colors[status] || "none"} ${hoverable ? 'hoverable' : null}`}/>)
}

export default EmailStatusChip;